<h1 mat-dialog-title>Gruppe(n) l&ouml;schen?</h1>
<div mat-dialog-content>
	M&ouml;chten Sie diese Gruppe(n) wirklich l&ouml;schen?
</div>
<mat-dialog-actions>
	<button mat-raised-button title="Abbrechen" (click)="cancelBtClick_DeleteGroupDialog()">Abbrechen</button>
	<button mat-raised-button title="Loeschen" (click)="deleteBtClick_DeleteGroupDialog()">L&ouml;schen</button>
</mat-dialog-actions>